import type { MovimentacaoFinanceiraView } from "../types/extrato-financeiro.types";

const CATEGORIA_DESPESA_LABEL: Record<string, string> = {
  INFRAESTRUTURA: "Infraestrutura",
  SERVICOS: "Serviços",
  EVENTOS: "Eventos",
  FORNECEDORES: "Fornecedores",
  IMPOSTOS: "Impostos",
  MARKETING: "Marketing",
  FRETE: "Frete",
  OPERACIONAL: "Operacional",
  OUTROS: "Outros",
};

function isDescricaoGenericaBaixa(descricao: string): boolean {
  const d = descricao.trim().toLowerCase();
  return (
    d === "baixa manual de título a pagar" ||
    d === "baixa manual de titulo a pagar" ||
    d === "baixa manual de título a receber" ||
    d === "baixa manual de titulo a receber"
  );
}

/** Texto principal amigável na listagem do extrato. */
export function descricaoExtratoPrincipal(row: MovimentacaoFinanceiraView): string {
  if (row.tituloPagarDescricao?.trim()) {
    return `Pagamento — ${row.tituloPagarDescricao.trim()}`;
  }
  if (row.tituloReceberDescricao?.trim()) {
    return `Recebimento — ${row.tituloReceberDescricao.trim()}`;
  }
  if (isDescricaoGenericaBaixa(row.descricao) && row.observacao?.trim()) {
    return row.observacao.trim();
  }
  return row.descricao;
}

/** Linha secundária sob a descrição (fornecedor, inscrição, centro…). */
export function subtituloExtrato(row: MovimentacaoFinanceiraView): string | null {
  const partes: string[] = [];
  if (row.tituloPagarFornecedor?.trim()) {
    partes.push(`Fornecedor: ${row.tituloPagarFornecedor.trim()}`);
  }
  if (row.tituloPagarCategoria) {
    partes.push(
      CATEGORIA_DESPESA_LABEL[row.tituloPagarCategoria] ?? row.tituloPagarCategoria,
    );
  }
  if (row.inscricaoNumero?.trim()) {
    partes.push(`Inscrição ${row.inscricaoNumero.trim()}`);
  }
  if (row.pedidoReferencia) {
    partes.push(`Pedido ${row.pedidoReferencia}`);
  }
  if (row.centroCustoNome && row.centroCustoNome !== "Sem centro") {
    partes.push(row.centroCustoNome);
  }
  return partes.length ? partes.join(" · ") : null;
}

export function referenciaExtratoResumida(row: MovimentacaoFinanceiraView): string {
  if (row.tituloPagarDescricao?.trim()) {
    const extra = row.tituloPagarFornecedor?.trim();
    return extra ? `${row.tituloPagarDescricao.trim()} (${extra})` : row.tituloPagarDescricao.trim();
  }
  if (row.tituloReceberDescricao?.trim()) {
    return row.tituloReceberDescricao.trim();
  }
  if (row.inscricaoNumero) return `Inscrição ${row.inscricaoNumero}`;
  if (row.pedidoReferencia) return `Pedido ${row.pedidoReferencia}`;
  if (row.tituloPagarId) return "Conta a pagar";
  if (row.tituloReceberId) return "Conta a receber";
  return "—";
}

export function labelCategoriaDespesa(codigo: string | null | undefined): string | null {
  if (!codigo) return null;
  return CATEGORIA_DESPESA_LABEL[codigo] ?? codigo;
}
